import { DragDropModule } from '@angular/cdk/drag-drop';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-docusign-guide',
  standalone: true,
  imports: [
    NgxExtendedPdfViewerModule,
    MatIconModule,
    DragDropModule,
    MatDialogModule, 
    MatButtonModule 
  ],
  template: `
  <div class="guide-container">
    <div class="modal-header" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
      <h5 style="margin-left: 8px; font-size: 16px">Docusign signing guide</h5>
      <button mat-icon-button mat-dialog-close aria-label="Close dialog" style="background-color: rgba(0, 0, 0, 0); border: none" >
          <mat-icon>close</mat-icon>
      </button>
    </div>
    <ngx-extended-pdf-viewer
    id="guideViewer"
    [zoom]="'90%'"
    [showPrintButton]="false"
    [showDownloadButton]="false"
    [showOpenFileButton]="false"
    [showRotateButton]="false"
    [showSecondaryToolbarButton]="false"
    [showDrawEditor]="false"
    [showTextEditor]="false"
    [showStampEditor]="false"
    [src]="'/assets/pdfs/docusign_guide.pdf'"
    >
    </ngx-extended-pdf-viewer>
  </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        height: 100%;
      }

      .guide-container {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        min-height: 0;
        height: 100%;
      }

      .modal-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        background-color: #f7f7f7;
        overflow: hidden;
        flex: 0 0 auto;
      }

      ngx-extended-pdf-viewer {
        flex: 1 1 auto;
        min-height: 0;
      }
    `
  ]
})
export class DocusignGuideComponent {

}
